import { Entry, EntryCollection } from "contentful";
import { get } from "lodash-es";

import { useServerSideProps } from "~/contexts/server-side-props";

import { assertEditorialType, isActiveEntry } from "./editorial-utils";
import objectUtils from "./object-utils";

const translationUtils = {
  parseTranslationLabel(entry: Entry<unknown>) {
    if (!isActiveEntry(entry)) return { key: "", value: "" };
    assertEditorialType<{ key: string; value: string }>(entry, "translationLabel");

    return entry.fields;
  },
  parseMultipleTranslationLabels(collection: Omit<EntryCollection<unknown>, "stringifySafe" | "toPlainObject">) {
    const labels = collection.items.map((item) => this.parseTranslationLabel(item));
    const record = labels.reduce((acc, next) => ({ ...acc, [next.key]: next.value || null }), {});

    return objectUtils.nestDottedKeys(record);
  },
};

export function useTranslateWithFallback() {
  const { serverSideProps } = useServerSideProps();

  return function (key: string, fallback?: string | null) {
    const value = get(serverSideProps.messages, key.split(".")) as string | undefined;

    return value || fallback || key;
  };
}

export default translationUtils;
